// Імпорт бібліотек
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

// Селектори
const datetimePicker = document.querySelector("#datetime-picker");
const startBtn = document.querySelector("[data-start]");
const daysEl = document.querySelector("[data-days]");
const hoursEl = document.querySelector("[data-hours]");
const minutesEl = document.querySelector("[data-minutes]");
const secondsEl = document.querySelector("[data-seconds]");

let selectedDate = null;
let timerId = null;

// Налаштування flatpickr
flatpickr(datetimePicker, {
  enableTime: true,
  time_24hr: true,
  defaultDate: new Date(),
  minuteIncrement: 1,
  onClose(selectedDates) {
    selectedDate = selectedDates[0];

    if (selectedDate <= new Date()) {
      iziToast.error({ title: "Error", message: "Please choose a date in the future", position: "center" });
      startBtn.disabled = true;
    } else {
      startBtn.disabled = false;
    }
  },
});

// Функція форматування з ведучим нулем
function addLeadingZero(value) {
  return String(value).padStart(2, "0");
}

// Функція конвертації мс у дні, години, хвилини, секунди
function convertMs(ms) {
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const days = Math.floor(ms / day);
  const hours = Math.floor((ms % day) / hour);
  const minutes = Math.floor(((ms % day) % hour) / minute);
  const seconds = Math.floor((((ms % day) % hour) % minute) / second);

  return { days, hours, minutes, seconds };
}

// Функція оновлення інтерфейсу
function updateTimer({ days, hours, minutes, seconds }) {
  daysEl.textContent = addLeadingZero(days);
  hoursEl.textContent = addLeadingZero(hours);
  minutesEl.textContent = addLeadingZero(minutes);
  secondsEl.textContent = addLeadingZero(seconds);
}

// Обробка кнопки Start
startBtn.addEventListener("click", () => {
  if (!selectedDate) return;

  // Деактивуємо інпут і кнопку
  datetimePicker.disabled = true;
  startBtn.disabled = true;

  timerId = setInterval(() => {
    const now = new Date();
    const diff = selectedDate - now;

    if (diff <= 0) {
      clearInterval(timerId);
      updateTimer({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      datetimePicker.disabled = false; // інпут можна редагувати для нового таймера
      iziToast.info({ title: "Info", message: "Time is up!", position: "center" });
      return;
    }

    const timeLeft = convertMs(diff);
    updateTimer(timeLeft);
  }, 1000);
});
